import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets//images/clock.png'


const _withScopeId = n => (_pushScopeId("data-v-4b4c4cd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "clock",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_line_chart = _resolveComponent("line-chart")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_raddar_chart = _resolveComponent("raddar-chart")!
  const _component_pie_chart = _resolveComponent("pie-chart")!
  const _component_VisualizationTable = _resolveComponent("VisualizationTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("vehiclemanagement")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `${_ctx.routerName.vehiclelist}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("vehiclelist")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("resourcestatistics")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_date_picker, {
          value: _ctx.statisticsTime,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.statisticsTime) = $event)),
          format: 'YYYY-MM-DD HH:mm:ss',
          "disabled-date": _ctx.disabledDate,
          "show-time": { defaultValue: _ctx.dayjs('00:00:00', 'HH:mm:ss') },
          onChange: _ctx.onChange
        }, {
          suffixIcon: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["value", "disabled-date", "show-time", "onChange"])
      ]),
      _createVNode(_component_a_button, {
        class: "searchBtn",
        style: {"float":"right"},
        type: "primary",
        onClick: _ctx.showType
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("switchdisplaymode")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_a_row, { class: "container-top" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            span: 11,
            class: "box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_line_chart, { detail: _ctx.detail }, null, 8, ["detail"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            span: 11,
            offset: 1,
            class: "box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bar_chart, { detail: _ctx.detail }, null, 8, ["detail"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            class: "box",
            span: 11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_raddar_chart, { detail: _ctx.detail }, null, 8, ["detail"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            class: "box",
            span: 11,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_pie_chart, { detail: _ctx.detail }, null, 8, ["detail"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, !_ctx.isShow]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_VisualizationTable, { detail: _ctx.detail }, null, 8, ["detail"])
    ], 512), [
      [_vShow, _ctx.isShow]
    ])
  ]))
}